<div class="flex flex-col justify-center items-center min-h-screen bg-background">
	<div class="flex bg-white shadow-lg rounded-2xl overflow-hidden w-full max-w-4xl">
		<div class="w-full lg:w-1/2 px-8 py-10">
			<img [src]="branding.LOGO" [alt]="branding.APP_NAME" class="h-12 mb-5" />
			<h1 class="text-3xl font-bold mb-2 text-primary-dark">Olá!</h1>
			<p class="font-normal mb-10 text-primary-gray">
				Por favor, informe o seu e-mail e senha para continuar o seu acesso.
			</p>
			<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
				<div class="mb-4">
					<label for="email" class="input-label">
						E-mail
					</label>
					<div class="input-field"
						[ngClass]="{'input-field-error': loginForm.get('email')?.invalid && !emailFocused && loginForm.get('email')?.touched && loginForm.get('email')?.value, 'input-field-focus': !(loginForm.get('email')?.invalid && !emailFocused && loginForm.get('email')?.touched && loginForm.get('email')?.value)}">
						<img [src]="icons.EMAIL" alt="" class="w-4 h-4" />
						<input id="email" type="email" formControlName="email" placeholder="Insira o seu e-mail"
							class="input-element py-3" (focus)="emailFocused = true" (blur)="emailFocused = false" />
					</div>
					<div *ngIf="loginForm.get('email')?.invalid && !emailFocused && loginForm.get('email')?.touched && loginForm.get('email')?.value"
						class="text-red-500 text-sm mt-1">
						<div *ngIf="loginForm.get('email')?.errors?.['required']">E-mail é obrigatório.</div>
						<div *ngIf="loginForm.get('email')?.errors?.['email']">E-mail inválido.</div>
					</div>
				</div>
				<div>
					<label for="password" class="input-label">
						Senha
					</label>
					<div class="input-field"
						[ngClass]="{'input-field-error': loginForm.get('password')?.invalid && !passwordFocused && loginForm.get('password')?.touched && loginForm.get('password')?.value, 'input-field-focus': !(loginForm.get('password')?.invalid && !passwordFocused && loginForm.get('password')?.touched && loginForm.get('password')?.value)}">
						<img [src]="icons.PASSWORD" alt="" class="w-4 h-4" />
						<input id="password" [type]="passwordVisible ? 'text' : 'password'" formControlName="password"
							placeholder="Insira a sua senha" class="input-element py-3" (focus)="passwordFocused = true"
							(blur)="passwordFocused = false" />
						<button type="button" (mousedown)="$event.preventDefault();"
							(click)="this.passwordVisible = !this.passwordVisible" class="px-2 focus:outline-none">
							<img [src]="passwordVisible ? icons.VISIBILITY_OFF : icons.VISIBILITY" alt="" class="w-[18px] h-4" />
						</button>
					</div>
					<div *ngIf="loginForm.get('password')?.invalid && !passwordFocused && loginForm.get('password')?.touched && loginForm.get('password')?.value"
						class="text-red-500 text-sm mt-1">
						<div *ngIf="loginForm.get('password')?.errors?.['required']">Senha é obrigatória.</div>
						<div *ngIf="loginForm.get('password')?.errors?.['minlength']">
							Senha deve ter pelo menos 8 caracteres.
						</div>
						<div *ngIf="loginForm.get('password')?.errors?.['pattern']">
							Senha deve conter letras maiúsculas, minúsculas e caracteres especiais.
						</div>
					</div>
				</div>
				<div class="flex justify-start">
					<a class="text-sm font-medium text-secondary hover:underline my-5"
						(click)="navigateToRecuperarSenha()">Esqueceu
						a senha?</a>
				</div>
				<button type="submit" class="button-standard button-color-primary"
					[ngClass]="{'button-disabled': loginForm.invalid}" [disabled]="loginForm.invalid">
					Acessar
				</button>
			</form>
		</div>
		<div class="hidden lg:flex lg:flex-1 lg:basis-1/2 bg-cover bg-center rounded-r-2xl self-stretch"
			[style.background-image]="'url(' + branding.LOGIN_BACKGROUND + ')'">
		</div>
	</div>
	<div class="flex flex-col mt-4 text-center">
		<p class="text-sm text-gray-700 mb-2">
			Desenvolvido com <span class="text-lg">♡</span> por
		</p>
		<img [src]="branding.DEVELOPER_LOGO" [alt]="branding.DEVELOPER_NAME" class="h-8 mb-8 object-contain" />
	</div>
</div>